<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          FAQ 등록
        </div>
        <div>
          <board-write-component :board-type="`faqCreate`"></board-write-component>
        </div>
        <div class="pa15 text-center btn_wrap">
          <el-button class="reg_btn_out" @click="save">저장</el-button>
<!--          <el-button class="com_btn" @click="backEvent()" :disabled="disableBtn">목록</el-button>-->
          <el-button class="com_btn" @click="backEvent()">목록</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardWriteComponent from "@/components/board/BoardWriteComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "FaqCreate",
  mixins: [],
  components: {
    BoardWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      disableBtn: false,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    save() {
      EventBus.$emit('writeBoard');
    },
    backEvent() {
      this.disableBtn = true
      this.$router.back()
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>